export default __webpack_public_path__ + "static/media/ivana-squares.123e41b2.jpg";